import { Coins, ArrowUpRight, ExternalLink, CheckCircle2 } from "lucide-react";

export default function Foerdermittel() {
  return (
    <section
      id="foerdermittel"
      data-testid="foerdermittel-section"
      className="section-padding bg-white border-b border-black/10"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="overline mb-4">Säule 03 · Förder­mittel</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Förder­mittel
              <br />
              & Zuschüsse —
              <br />
              <span className="text-[#D30000]">erfolgs­basiert.</span>
            </h2>
            <div className="mt-6 text-xs uppercase tracking-[0.2em] text-[#4A4A52]">
              Für investierende Unternehmen · Mittelstand & gehobener Mittelstand
            </div>

            <div className="mt-10 w-14 h-14 border border-black/15 flex items-center justify-center">
              <Coins size={22} strokeWidth={1.5} />
            </div>

            <div className="mt-10 border border-black/10 p-6 max-w-md">
              <div className="text-xs uppercase tracking-[0.2em] text-[#D30000] mb-3">
                Kooperation
              </div>
              <div className="font-display font-bold text-xl tracking-tight">
                REM Capital AG · Stuttgart
              </div>
              <p className="mt-3 text-sm text-[#4A4A52] leading-relaxed">
                Als Repräsentant der REM Capital AG bringe ich deren
                etablierte Förder­mittel­expertise in den persönlichen
                Dialog mit Unter­nehmen — Analyse, Strukturierung und
                Beantragung komplexer öffentlicher Förder­mittel aus einer
                Hand.
              </p>
              <a
                href="https://www.remcapital.de"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="remcapital-link"
                className="mt-4 inline-flex items-center gap-2 text-sm font-semibold hover-marker"
              >
                remcapital.de <ExternalLink size={14} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-base md:text-lg leading-relaxed text-[#4A4A52] max-w-2xl">
              Investitions­vorhaben im Mittel­stand werden häufig teurer
              realisiert als nötig — weil verfügbare Förder­mittel, Zuschüsse
              und Förder­darlehen übersehen oder nicht sauber strukturiert
              eingebunden werden. Genau an dieser Stelle setzt dieses
              Angebot an.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-[#4A4A52] max-w-2xl">
              Gemeinsam mit der REM Capital AG begleite ich Unternehmen von
              der ersten Idee bis zur erfolgreichen Realisierung — und das
              <span className="font-medium text-[#0A0A0A]"> ganz überwiegend auf Erfolgs­basis</span>:
              Honoriert wird, was wirklich fließt.
            </p>

            <ul className="mt-10 space-y-4">
              <ItemRow
                label="Analyse"
                text="Identifikation geeigneter Förder­programme auf Bundes-, Landes- und EU-Ebene — passgenau zum Investitions­vorhaben."
              />
              <ItemRow
                label="Strukturierung"
                text="Einbettung der Förder­mittel in den Finanzierungs­mix, Timing und Antrags­strategie."
              />
              <ItemRow
                label="Antrag"
                text="Erstellung und Einreichung der Antrags­unterlagen inkl. begleitender Nach­weise und Berichte."
              />
              <ItemRow
                label="Umsetzung"
                text="Begleitung bis zum Mittel­abruf und bei allen Rück­fragen der Bewilligungs­stellen."
              />
            </ul>

            <div className="mt-12 border-t border-black/10 pt-8">
              <div className="overline mb-5">Typische Einsatzgebiete</div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3">
                <Bullet text="Maschinen- und Anlagen­investitionen" />
                <Bullet text="Transformation & Nachhaltigkeit" />
                <Bullet text="Digitalisierung & Automatisierung" />
                <Bullet text="Energie­effizienz & Dekarbonisierung" />
                <Bullet text="Forschung & Entwicklung" />
                <Bullet text="Immobilien- und Standort­projekte" />
              </ul>
            </div>

            <a
              href="#kontakt"
              className="mt-10 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] hover-marker w-fit"
              data-testid="foerdermittel-cta"
            >
              Erstgespräch zu Förder­mitteln <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ItemRow({ label, text }) {
  return (
    <li className="grid grid-cols-[140px_1fr] gap-4 border-t border-black/10 pt-4 first:border-t-0 first:pt-0">
      <span className="font-mono text-xs uppercase tracking-[0.18em] text-[#0A0A0A] pt-1">
        {label}
      </span>
      <span className="text-base leading-relaxed text-[#4A4A52]">{text}</span>
    </li>
  );
}

function Bullet({ text }) {
  return (
    <li className="flex items-start gap-3 text-sm md:text-base text-[#4A4A52]">
      <CheckCircle2 size={16} className="text-[#D30000] shrink-0 mt-1" strokeWidth={1.75} />
      <span>{text}</span>
    </li>
  );
}
